import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface BurgerProps {
  className?: string
  onClick?: () => void
  isOpen?: boolean
}

function Burger({ className, onClick, isOpen }: BurgerProps) {
  const t = useTranslate()
  return (
    <button
      className={cx(css.Burger, className, { isOpen })}
      aria-label={t('aria-label.burgermenu')}
      onClick={onClick}
      aria-haspopup={true}
      aria-expanded={isOpen}>
      <div className={css.line} />
      <div className={css.line} />
      <div className={css.line} />
    </button>
  )
}

Burger.defaultProps = {}

export default Burger
